export default (theme) => ({
  root: {
  },
  avatar: {
    width: 48,
    height: 48,
  },
  card: {
  },
  cardContainer: {
    height: 60,
    marginBottom: theme.spacing(3),
  },
  content: {
    flexGrow: 1,
  },
  footer: {
    width: '100%',
    borderTop: `1px solid ${theme.palette.facet.border}`,
    paddingTop: theme.spacing(1),
  },
});
